import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  markAsPublished(event) {
    const input = document.getElementById("button_action_input")
    if (input) {
      input.value = "Publish"
    }
  }
}
